import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { Alert, Button, Row, Col, message } from 'antd';

import { api } from '../../../services';

import './Step_6.css';

@inject('translationsStore', 'registrationStore', 'profileStore')
@observer
export default class Step_6 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inProgress: false,
      resettingSignature: false,
    };

    if (!this.props.registrationStore.session) {
      this.props.history.push('/registrations');
    }
  }

  componentDidMount() {
    this.props.registrationStore.setPosition(7);
    this.props.registrationStore.user &&
      api({ action: 'get user' }, this.props.registrationStore.user._id).then(
        (user) => {
          this.props.registrationStore.setUser(user);
        }
      );
  }

  handleResetSignature = () => {
    const { user } = this.props.registrationStore;
    const { current: t } = this.props.translationsStore;

    if (user && user._id) {
      this.setState({ resettingSignature: true });

      api({ action: 'reset signature method' }, user._id)
        .then(() => {
          this.setState({ resettingSignature: false });
          this.props.history.push('/registrations');
        })
        .catch((error) => {
          console.error('Error resetting signature method:', error);
          message.error(
            t['shared']['lblOperationFailed'] || 'Operazione fallita'
          );
          this.setState({ resettingSignature: false });
        });
    }
  };

  alertMessage() {
    const { current: t } = this.props.translationsStore;
    const { user } = this.props.registrationStore;

    const onClickHandler = (e) => {
      this.setState({ inProgress: true });
      api({ action: 'send validation' }, user._id, user.assets[0].imei)
        .then(() => {
          api({ action: 'send contracts' }, user._id, user.assets[0].imei)
            .then(() => {
              message.info(`${t['shared']['lblMailSent']} ${user.email}`);
              this.setState({ inProgress: false });
            })
            .catch((error) => {
              message.error(
                `${t['shared']['lblMailSentError']}  ${user.email}`
              );
              this.setState({ inProgress: false });
            });
        })
        .catch(() => {
          message.error(`${t['shared']['lblMailSentError']}  ${user.email}`);
          this.setState({ inProgress: false });
        });
    };

    return (
      <Row className='alert'>
        <Col>{t['registration_6']['subheader']}</Col>
        <Col>{t['registration_6']['subheader2']}</Col>
        <Button onClick={onClickHandler} loading={this.state.inProgress}>
          {t['registration_6']['btnSendCustomerEmail']}
        </Button>
      </Row>
    );
  }

  render() {
    const { current: t } = this.props.translationsStore;
    const { user } = this.props.registrationStore;
    return (
      <div className='Step_6'>
        <div>
          {user &&
            user.assets &&
            user.assets[0] &&
            user.assets[0].subscription.signatureMethod !== 'digital' && (
              <Alert type='success' message={this.alertMessage()} />
            )}
          {user && user.notified && (
            <Alert
              type='warning'
              showIcon
              message={t['registration_6']['lblAlarmEmailAlreadySent']}
            />
          )}
          {user &&
            user.assets &&
            user.assets[0] &&
            user.assets[0].subscription.signatureMethod === 'digital' && (
              <React.Fragment>
                <Alert
                  type='warning'
                  showIcon
                  message={t['registration_6']['lblDigitalSignature']}
                />
                <div className='signature-reset-container'>
                  <span>{t['registration_6']['lblResetSignatureMethod']}</span>
                  <Button
                    type='primary'
                    onClick={this.handleResetSignature}
                    loading={this.state.resettingSignature}
                  >
                    {t['registration_6']['btnGoBack']}
                  </Button>
                </div>
              </React.Fragment>
            )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RegistrationSteps/Step_6/Step_6.js